<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar rounded="" color="secondary" dense elevation="1">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & Inventory'}, {text: 'Measure Unit'} ,{text: 'Create Warehouse',}]" large/>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Warehouse
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave" v-if="this.hasPermission(this.perm.warehouse.create)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" v-if="this.hasPermission(this.perm.warehouse.index)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <v-divider></v-divider>
                    <WarehouseForm ref="form" v-model="data" class="pa-3"/>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import WarehouseForm from './../../components/warehouse/WarehouseForm';
import PIconBtn from "./../../components/common/PIconBtn";
import PAlert from "./../../components/common/PAlert.vue";
import { v4 as uuid } from 'uuid';
import permissions from '../../data/permissions';
export default {
    name: "WarehouseCreateView",
    components: {
        PIconBtn,
        WarehouseForm,
        PAlert
    },
    data() {
        return {
            data : null,
            loading : false ,
            idempotentKey: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "warehouse/warehouse/create",
            snackbar: "ui/snackbar/show"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return ;
            this.loading = true
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({ color: "success", text: "Warehouse Created" })
                this.$router.push({ name: "WarehouseDisplay", params: {id: response.data.id}})
             }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "WarehouseList"})
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>